import { BigNumber } from 'ethers/utils'

import { NetworkId } from 'util/types'

export const ZERO_BN = new BigNumber(0)
export const INFURA_ID = process.env.REACT_APP_INFURA_ID
export const DEFAULT_NETWORK_ID: NetworkId = Number(
  process.env.REACT_APP_DEFAULT_NETWORK_ID || 1
) as NetworkId

export const CTE_GRAPH_HTTP_MAINNET =
  process.env.REACT_APP_CTE_GRAPH_HTTP_MAINNET ||
  'https://api.thegraph.com/subgraphs/name/gnosis/hg'
export const CTE_GRAPH_HTTP_RINKEBY =
  process.env.REACT_APP_CTE_GRAPH_HTTP_RINKEBY ||
  'https://api.thegraph.com/subgraphs/name/gnosis/hg-rinkeby'
export const CTE_GRAPH_HTTP_GANACHE =
  process.env.REACT_APP_CTE_GRAPH_HTTP_GANACHE || 'http://localhost:8000/subgraphs/name/gnosis/hg'
export const CTE_GRAPH_HTTP_XDAI =
  process.env.REACT_APP_CTE_GRAPH_HTTP_XDAI ||
  'https://api.thegraph.com/subgraphs/name/davidalbela/conditional-tokens-xdai'

export const OMEN_GRAPH_HTTP_MAINNET =
  process.env.REACT_APP_OMEN_GRAPH_HTTP_MAINNET ||
  'https://api.thegraph.com/subgraphs/name/gnosis/omen'
export const OMEN_GRAPH_HTTP_RINKEBY =
  process.env.REACT_APP_OMEN_GRAPH_HTTP_RINKEBY ||
  'https://api.thegraph.com/subgraphs/name/gnosis/omen-rinkeby'
export const OMEN_GRAPH_HTTP_XDAI =
  process.env.REACT_APP_OMEN_GRAPH_HTTP_XDAI ||
  'https://api.thegraph.com/subgraphs/name/protofire/omen-xdai'

export const BYTES_REGEX = /^0x[a-fA-F0-9]{64}$/
export const NULL_PARENT_ID = '0x0000000000000000000000000000000000000000000000000000000000000000'
export const ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/
export const INTEGER_NUMBER = /^[0-9]+$/
export const MIN_OUTCOMES = 2
export const MAX_OUTCOMES = 256

export const EARLIEST_MAINNET_BLOCK_TO_CHECK = Number(
  process.env.REACT_APP_EARLIEST_MAINNET_BLOCK_TO_CHECK || 9294139
)
export const EARLIEST_RINKEBY_BLOCK_TO_CHECK = Number(
  process.env.REACT_APP_EARLIEST_RINKEBY_BLOCK_TO_CHECK || 6127043
)
export const EARLIEST_GANACHE_BLOCK_TO_CHECK = Number(
  process.env.REACT_APP_EARLIEST_GANACHE_BLOCK_TO_CHECK || 0
)

export const EARLIEST_XDAI_BLOCK_TO_CHECK = Number(
  process.env.REACT_APP_EARLIEST_GANACHE_BLOCK_TO_CHECK || 0
)

export const INFORMATION_NOT_AVAILABLE = 'Information not available'

export const LOGGER_ID: string =
  process.env.REACT_APP_LOGGER_ID || 'gnosis-conditional-token-explorer'

export const CONDITIONAL_TOKEN_CONTRACT_ADDRESS_FOR_MAINNET =
  process.env.REACT_APP_CONDITIONAL_TOKEN_CONTRACT_ADDRESS_FOR_MAINNET ||
  '0xC59b0e4De5F1248C1140964E0fF287B192407E0C'
export const CONDITIONAL_TOKEN_CONTRACT_ADDRESS_FOR_RINKEBY =
  process.env.REACT_APP_CONDITIONAL_TOKEN_CONTRACT_ADDRESS_FOR_RINKEBY ||
  '0x36bede640D19981A82090519bC1626249984c908'
export const CONDITIONAL_TOKEN_CONTRACT_ADDRESS_FOR_GANACHE =
  process.env.REACT_APP_CONDITIONAL_TOKEN_CONTRACT_ADDRESS_FOR_GANACHE ||
  '0xA57B8a5584442B467b4689F1144D269d096A3daF'
export const CONDITIONAL_TOKEN_CONTRACT_ADDRESS_FOR_XDAI =
  process.env.REACT_APP_CONDITIONAL_TOKEN_CONTRACT_ADDRESS_FOR_XDAI ||
  '0xCeAfDD6bc0bEF976fdCd1112955828E00543c0Ce'

export const REALITY_CONTRACT_ADDRESS_FOR_MAINNET =
  process.env.REACT_APP_REALITY_CONTRACT_ADDRESS_FOR_MAINNET ||
  '0x325a2e0f3cca2ddbaebb4dfc38df8d19ca165b47'
export const REALITY_CONTRACT_ADDRESS_FOR_RINKEBY =
  process.env.REACT_APP_REALITY_CONTRACT_ADDRESS_FOR_RINKEBY ||
  '0x3D00D77ee771405628a4bA4913175EcC095538da'
export const REALITY_CONTRACT_ADDRESS_FOR_GANACHE =
  process.env.REACT_APP_REALITY_CONTRACT_ADDRESS_FOR_GANACHE ||
  '0xcfeb869f69431e42cdb54a4f4f105c19c080a601'
export const REALITY_CONTRACT_ADDRESS_FOR_XDAI =
  process.env.REACT_APP_REALITY_CONTRACT_ADDRESS_FOR_XDAI ||
  '0x79e32aE03fb27B07C89c0c568F80287C01ca2E57'

export const WRAPPED_1155_FACTORY_CONTRACT_ADDRESS_FOR_MAINNET =
  process.env.REACT_APP_WRAPPED_1155_FACTORY_CONTRACT_ADDRESS_FOR_MAINNET ||
  '0xEC9Cc78463b72D7246E8189Df5EeD5fDc3508E71'
export const WRAPPED_1155_FACTORY_CONTRACT_ADDRESS_FOR_RINKEBY =
  process.env.REACT_APP_WRAPPED_1155_FACTORY_CONTRACT_ADDRESS_FOR_RINKEBY ||
  '0xEC9Cc78463b72D7246E8189Df5EeD5fDc3508E71'
export const WRAPPED_1155_FACTORY_CONTRACT_ADDRESS_FOR_GANACHE =
  process.env.REACT_APP_WRAPPED_1155_FACTORY_CONTRACT_ADDRESS_FOR_GANACHE || ''
export const WRAPPED_1155_FACTORY_CONTRACT_ADDRESS_FOR_XDAI =
  process.env.REACT_APP_WRAPPED_1155_FACTORY_CONTRACT_ADDRESS_FOR_XDAI ||
  '0xDE6943f3717738038159a406FF157d4eb3238c1B'

// Oracle Kleros
export const ORACLE_KLEROS_ADDRESS_MAINNET =
  process.env.REACT_APP_ORACLE_KLEROS_ADDRESS_MAINNET ||
  '0x0000000000000000000000000000000000000000'
export const ORACLE_KLEROS_ADDRESS_RINKEBY =
  process.env.REACT_APP_ORACLE_KLEROS_ADDRESS_RINKEBY ||
  '0x0000000000000000000000000000000000000000'
export const ORACLE_KLEROS_ADDRESS_GANACHE =
  process.env.REACT_APP_ORACLE_KLEROS_ADDRESS_GANACHE ||
  '0x0000000000000000000000000000000000000000'
export const ORACLE_KLEROS_ADDRESS_XDAI =
  process.env.REACT_APP_ORACLE_KLEROS_ADDRESS_XDAI || '0x0000000000000000000000000000000000000000'

// Oracle Reality
export const ORACLE_REALITY_ADDRESS_MAINNET =
  process.env.REACT_APP_ORACLE_REALITY_ADDRESS_MAINNET ||
  '0x0e414d014a77971f4eaa22ab58e6d84d16ea838e'
export const ORACLE_REALITY_ADDRESS_RINKEBY =
  process.env.REACT_APP_ORACLE_REALITY_ADDRESS_RINKEBY ||
  '0x17174dC1b62add32a1DE477A357e75b0dcDEed6E'
export const ORACLE_REALITY_ADDRESS_GANACHE =
  process.env.REACT_APP_ORACLE_REALITY_ADDRESS_GANACHE ||
  '0xDb56f2e9369E0D7bD191099125a3f6C370F8ed15'
export const ORACLE_REALITY_ADDRESS_XDAI =
  process.env.REACT_APP_ORACLE_REALITY_ADDRESS_XDAI || '0xAB16D643bA051C11962DA645f74632d3130c81E2'

// Arbitrator Kleros
export const ARBITRATOR_KLEROS_ADDRESS_MAINNET =
  process.env.REACT_APP_ARBITRATOR_KLEROS_ADDRESS_MAINNET ||
  '0xd47f72a2d1d0E91b0Ec5e5f5d02B2dc26d00A14D'
export const ARBITRATOR_KLEROS_ADDRESS_RINKEBY =
  process.env.REACT_APP_ARBITRATOR_KLEROS_ADDRESS_RINKEBY ||
  '0xcafa054b1b054581faf65adce667bf1c684b6ef0'
export const ARBITRATOR_KLEROS_ADDRESS_GANACHE =
  process.env.REACT_APP_ARBITRATOR_KLEROS_ADDRESS_GANACHE ||
  '0x0000000000000000000000000000000000000000'
export const ARBITRATOR_KLEROS_ADDRESS_XDAI =
  process.env.REACT_APP_ARBITRATOR_KLEROS_ADDRESS_XDAI ||
  '0xe40DD83a262da3f56976038F1554Fe541Fa75ecd'

// Arbitrator reality
export const ARBITRATOR_REALITY_ADDRESS_MAINNET =
  process.env.REACT_APP_ARBITRATOR_REALITY_ADDRESS_MAINNET ||
  '0xdc0a2185031ecf89f091a39c63c2857a7d5c301a'
export const ARBITRATOR_REALITY_ADDRESS_RINKEBY =
  process.env.REACT_APP_ARBITRATOR_REALITY_ADDRESS_RINKEBY ||
  '0x02321745bE4a141E78db6C39834396f8df00e2a0'
export const ARBITRATOR_REALITY_ADDRESS_GANACHE =
  process.env.REACT_APP_ARBITRATOR_REALITY_ADDRESS_GANACHE ||
  '0x0000000000000000000000000000000000000000'
export const ARBITRATOR_REALITY_ADDRESS_XDAI =
  process.env.REACT_APP_ARBITRATOR_REALITY_ADDRESS_XDAI ||
  '0x7202deD6f13525A8298Ea53fBFD4395fDCc8d5f1'

export const RPC_XDAI_CHAIN =
  process.env.REACT_APP_RPC_XDAI_CHAIN ||
  'https://rpc.gnosischain.com'

export const CONFIRMATIONS_TO_WAIT = Number(process.env.REACT_APP_CONFIRMATIONS_TO_WAIT || 4)

export const GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID || null

export const navItems = [
  {
    title: 'Conditions',
    url: '/conditions',
  },
  {
    title: 'Positions',
    url: '/positions',
  },
  {
    title: 'Prepare Condition',
    url: '/prepare',
  },
  {
    title: 'Split Position',
    url: '/split',
  },
  {
    title: 'Merge Positions',
    url: '/merge',
  },
  {
    title: 'Report Payouts',
    url: '/report',
  },
  {
    title: 'Redeem Positions',
    url: '/redeem',
  },
]

export const REALITY_TIMEOUT = process.env.REACT_APP_REALITY_TIMEOUT

export const SINGLE_SELECT_TEMPLATE_ID = 2

export const MIN_OUTCOMES_ALLOWED = Number(process.env.REACT_APP_MIN_OUTCOMES_ALLOWED || 2)

export const MAX_OUTCOMES_ALLOWED = Number(process.env.REACT_APP_MAX_OUTCOMES_ALLOWED || 256)

export const MIN_DATE = '2015-07-30'
export const MAX_DATE = '2030-01-01'

export const OMEN_URL_DAPP = process.env.REACT_APP_OMEN_URL_DAPP || 'https://omen.eth.link'

export const ICON_ENDPOINT =
  process.env.REACT_APP_ICON_ENDPOINT || 'https://gnosis-safe-token-logos.s3.amazonaws.com/{}.png'
